import { NavLink } from 'react-router-dom';

const listItem = (props) => {
    
    const { item } = props
    return (
        <div className="blog-card">
            <div className="blog-card_area">
                <div className="row">    
                    <p className="blog-heading">{item.headline}</p>
                </div>
                <div>
                    <p className="blog-date">{item.date}</p>
                    <p className="paragraph paragraph--light">{item.introduction}</p>
                    <p className="paragraph paragraph--light">{item.leadIn}</p>
                </div>
            </div>

            <div className="blog-link_centre">
                <NavLink className="blog-link" to={"/blogitem/" + item.id} exact>Continue reading here...</NavLink>
            </div>
        </div>
    )
}

export default listItem;